import * as React from 'react'

import { AlertKind } from 'main/ui'

export interface IPageAlert {
  kind: AlertKind
  body: React.ReactNode
}

export const successAlert: IPageAlert = {
  body: 'Successfully saved!',
  kind: 'success',
}

export const errorAlert: IPageAlert = {
  body: 'Oh no, something went wrong. Check your internet connection and try again.',
  kind: 'danger',
}
